import React from 'react'
import { useTranslation } from 'react-i18next';
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import { useDispatch, useSelector } from 'react-redux';
import HeaderWithBack from '../../components/Header/headerWithBack';
import moment from 'moment';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl } from '../../utils/Helper';
import CustomPressable from '../../components/customPressable/customPressable';

const ReservationsSummary = (props) => {
    const { selectedEvent, selectedVenue, selectedInventory, preferredDateTime, additionalInfo, handleNext, handleGoBack } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const { currentWidget, extraConfigParam } = useSelector(state => state.deviceConfigSlice);
    const dateFormat = extraConfigParam?.DATE_FORMAT;

    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    
    const renderHeader = () => {
        return <View style={getStyles(['widgetmainContainerHeaderContainer', 'reservationsHeaderContainer'])}>
            {
                currentWidget?.widgetHeaderImageUrl &&
                <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'reservationsHeaderImg'])} />
            }
            <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'reservationsHeaderTitleContainer'])}>
                <Text style={getStyles(['widgetmainContainerHeaderTitle', 'reservationsHeaderTitle'])}>{t('events.summary')}</Text>
            </View>
        </View>
    }
    return (
        <View style={getStyles(['widgetRootContainer', 'reservationsRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
                                    
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'reservationsMainContainer'])} 
                showsVerticalScrollIndicator={false}
            >
                {renderHeader()}

                <View style={getStyles(['widgetmainContainerChildContainer', 'reservationsMainContainerChildContainer'])}>
                    <View style={getStyles(['labelValueContainer'])}>
                        <Text style={getStyles(['labelValueContainer_label'])}>{t("events.date")}</Text>
                        <Text style={getStyles(['labelValueContainer_value'])}>{moment(preferredDateTime.date).format((dateFormat).toUpperCase())}</Text>
                    </View>

                    <View style={getStyles(['labelValueMainContainer'])}>
                        <Text style={getStyles(['labelValueContainer_label'])}>{t("events.details")}</Text>
                        <View style={getStyles(['labelValueContainer'])}>
                            <Text style={getStyles(['labelValueContainer_label'])}>{t("events.event_name")}</Text>
                            <Text style={getStyles(['labelValueContainer_value'])}>{selectedEvent.eventName}</Text>
                        </View>
                        <View style={getStyles(['labelValueContainer'])}>
                            <Text style={getStyles(['labelValueContainer_label'])}>{t("events.inventory_name")}</Text>
                            <Text style={getStyles(['labelValueContainer_value'])}>{JSON.parse(selectedInventory).inventory_name}</Text>
                        </View>
                        <View style={getStyles(['labelValueContainer'])}>
                            <Text style={getStyles(['labelValueContainer_label'])}>{t("events.venue")}</Text>
                            <Text style={getStyles(['labelValueContainer_value'])}>{JSON.parse(selectedVenue).venueName}</Text>
                        </View>
                        <View style={getStyles(['labelValueContainer'])}>
                            <Text style={getStyles(['labelValueContainer_label'])}>{t("events.guestCount")}</Text>
                            <Text style={getStyles(['labelValueContainer_value'])}>{preferredDateTime.guestCount}</Text>
                        </View>
                        <View style={getStyles(['labelValueContainer'])}>
                            <Text style={getStyles(['labelValueContainer_label'])}>{t("events.guestComment")}</Text>
                            <Text style={getStyles(['labelValueContainer_value'])}>{additionalInfo.guestComment}</Text>
                        </View>
                        <View style={getStyles(['labelValueContainer'])}>
                            <Text style={getStyles(['labelValueContainer_label'])}>{t("events.price")}</Text>
                            <Text style={getStyles(['labelValueContainer_value'])}>{currencyCode} {JSON.parse(selectedInventory).price}</Text>
                        </View>
                    </View>
                </View>
            </ScrollView>

            <View id='reservationsNextButtonContainer' style={getStyles(['reservationsNextButtonContainer'])}>
                <CustomPressable style={getStyles(["primaryBtn"])} onPress={()=> handleNext()} id="primaryBtn">
                    <Text style={getStyles(["primaryBtnTxt"])} id='primaryBtnTxt'>
                        {t("events.make_reservation")}
                    </Text>
                </CustomPressable>

                {/* <CustomPressable style={getStyles(["secondaryBtn"])} onPress={()=> handleGoBack()} id="secondaryBtn">
                    <Text style={getStyles(["secondaryBtnTxt"])} id='secondaryBtnTxt'>
                        {t("events.back")}
                    </Text>
                </CustomPressable> */}
            </View>
        </View>
    )
}

export default ReservationsSummary
